import { render } from "./PropertyForm.vue?vue&type=template&id=4896de68"
import script from "./PropertyForm.vue?vue&type=script&lang=js"
export * from "./PropertyForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__